import * as z from "zod";

export const analyzeSampleCustomers = {
  name: "analyzeSampleCustomers" as const,
  input: z.object({}),
  output: z.object({ analyzedCustomerIds: z.array(z.string()) }),
};
